import { selectActionCardsBy as e } from "./rankActions.mjs";
//#region src/selectHostActionCards.ts
var t = (t, n) => {
	let { cards: r, overflow: i } = e(t, n, (e) => e.type);
	return {
		cards: r,
		overflow: i.map(({ group: e, count: t, lead: n }) => ({
			type: e,
			count: t,
			lead: n
		}))
	};
};
//#endregion
export { t as selectHostActionCards };
